import { createApi } from '@/api/modules/utils'

const baseUrl = '/article_generation/personal/ai_create'
const api = createApi(baseUrl)

// AI创作相关API
export const articleGenerationAiCreateApi = {
    extendWriting: api('extend_writing', 'post'), //延展写作
    rewriteText: api('rewrite_text', 'post'), //改写文本
    contentPlan: api('content_plan', 'post'), //内容计划
    themeMap: api('theme_map', 'post'), //主题地图   
    articleThemeCreative: api('article_theme_creative', 'post'), //文章主题创意
    articleOutline: api('article_outline', 'post'), //文章大纲
    title: api('title', 'post'), //ai生成标题
    describe: api('describe', 'post'), //ai生成描述
    articleIntroduction: api('article_introduction', 'post'), //文章介绍
    paragraph: api('paragraph', 'post'), //段落
    commonQuestions: api('common_questions', 'post'), //常见问题
    productDescription: api('product_description', 'post'), //产品描述
    categoryDescription: api('category_description', 'post'), //类别描述
    productReview: api('product_review', 'post'), //产品评论
    youtubeDescription: api('youtube_description', 'post'), //YouTube描述
    email: api('email', 'post'), //电子邮件
    find: api('find', 'get'), //查询任务结果
}